// Shared status chip for license/trial listings
// Props:
// - expiresAt: Date string
// - statusFlag: boolean (true => expired but not accessed since; false => expired)
// - now: Date instance (optional)
// - expiringSoonMonths: number of months window for "Expiring Soon" (default 3)
export default function StatusChip({ expiresAt, statusFlag, now = new Date(), expiringSoondays = 3, pill = true }) {
  const expDate = new Date(expiresAt);
  const isExpired = expDate <= now;

  const isExpiringSoon = () => {
    if (isExpired) return false;
    // Approximate months as 30 days; aligns with request for 1 month
    const msInDay = 24 * 60 * 60 * 1000;
    const threshold = now.getTime() + expiringSoondays * msInDay;
    return expDate.getTime() > now.getTime() && expDate.getTime() <= threshold;
  };

  let label = 'Active';
  let cls = 'status-active';

  if (isExpiringSoon()) {
    label = 'Expiring Soon';
    cls = 'status-expiring';
  } else if (isExpired) {
    if (statusFlag) {
      label = 'Expired Pending';
      cls = 'status-expired-pending';
    } else {
      label = 'Expired';
      cls = 'status-expired';
    }
  }
  if (!pill) {
    return <span>{label}</span>;
  }

  return <span className={`status-chip ${cls}`}>{label}</span>;
}